<template>
  <div>
    <DocumentTableViewer
      :documents="documents"
      :loading="loading"
      :removable="!disabled"
      :fullViewMode="singleZip"
      @remove="remove"
    />

    <div class="d-flex">
      <UploadDocument
        v-if="!disabled"
        :disabled="disabledAddDocumentButton"
        :has-description="true"
        :accept-file="acceptFile"
        :accept-sign="acceptSign"
        :max-length="maxLength"
        :single-zip="singleZip"
        :max-file-size="maxFileSize"
        @change="changeUploadDocumentHandler"
        :withSelect="withSelect"
        :documentTypes="filteredDocumentTypes"
        :translationKey="translationKey ? `${translationKey}.upload` : undefined"
      />

      <LoadDocumentProfile
        v-if="canLoadFromProfile"
        :multiple="true"
        @change="changeLoadDocumentProfileHandler"
        class="ml-5"
      />
    </div>

    <div class="ud-error">
      <div class="ud-error__wrapper">
        <div
          class="ud-error__text"
          v-for="(error, index) in errorMessages"
          :key="index"
        >
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';

import { deleteFile } from '@/api/filestorage';
import { ErrorAlertModule } from '@/store/modules/errors';
import { errorHandler, isNotEmptyObjectCheck } from '@/utils/common';
import DocumentTableViewer from '@/components/base/DocumentTableViewer';
import LoadDocumentProfile from './LoadDocumentProfile';
import UploadDocument from './UploadDocument';

export default {
  name: 'AttachDocumentMultiple',
  model: {
    prop: 'documents',
    event: 'change',
  },
  components: { DocumentTableViewer, UploadDocument, LoadDocumentProfile },
  data: () => ({
    loading: false,
    loadingRemove: false,
    validationErrorMessages: []
  }),
  props: {
    documents: {
      type: Array,
      required: true,
    },
    errorMessages: {
      type: Array,
    },
    maxLength: {
      type: Number,
    },
    single: {
      type: Boolean,
      default: false,
      required: false,
    },
    singleZip: {
      type: Boolean,
      default: false,
      required: false,
    },
    canLoadFromProfile: {
      type: Boolean,
      default: false,
    },
    acceptFile: {
      type: Array,
    },
    acceptSign: {
      type: Array,
    },
    maxFileSize: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    withSelect: {
      type: Boolean,
      default: false
    },
    documentTypes: {
      type: Array,
      required: false,
    },
    translationKey: {
      type: String,
      default: 'common.attachDocumentMultiple'
    }
  },
  computed: {
    disabledAddDocumentButton() {
      return (this.single || this.singleZip) && this.documents.length !== 0;
    },
    filteredDocumentTypes() {
      if (!(this.documentTypes && this.documents)) return
			const excluded = ['11201', '11202', '11203', '12199', '12201', '12202', '12299', '12302', '12399']
      const addedDocuments = this.documents.map(item => item.description)
      return this.documentTypes.map(type => {
        return {
          ...type,
          documents: type.documents.filter(doc => {
						if (excluded.includes(doc.value)) {
							return true
						} else if (!addedDocuments.includes(doc.value)) {
							return true
						}
						return false
					})
        }
      })
    }
  },
  methods: {
    changeLoadDocumentProfileHandler(documents) {
      if (isNotEmptyObjectCheck(documents)) {
        this.$emit('change', [
          ...cloneDeep(this.documents),
          ...cloneDeep(documents),
        ]);
      }
    },

    changeUploadDocumentHandler(document) {
      if (this.single || this.singleZip) {
        this.$emit('change', [document]);
      } else {
        this.$emit('change', [...cloneDeep(this.documents), document]);
      }
    },

    async remove(document) {
      this.loading = true;
      this.loadingRemove = true;
      ErrorAlertModule.setErrorAlert('');

      try {
        await deleteFile(document.fileSig.link);

        const deletedIndex = this.documents.findIndex(
          (doc) => doc.fileSig.link === document.fileSig.link
        );

        const documents = cloneDeep(this.documents);
        documents.splice(deletedIndex, 1);

        this.$emit('change', documents);
      } catch (error) {
        errorHandler(error);
      }

      this.loadingRemove = false;
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.ud-error {
  padding-bottom: 16px;
}

.ud-error__text {
  padding-top: 10px;
  font-size: 12px;
  line-height: 1;
  color: $color-error;
  white-space: pre;
}

.ud-error__wrapper {
  min-height: 12px;
}
</style>
